import { createSlice } from "@reduxjs/toolkit";
import {
  getWaterfallFlow,
  createWaterfallFlow,
  updateWaterfallFlow,
  deleteWaterfallFlow,
  clearLocalActiveWaterfallFlow
} from './actions';

export const initialState = {
  waterfallFlow: { id: '', email: '', first_prompt: '', second_prompt: '', third_prompt: '', fourth_prompt: '', updated_at: '' },
  loading: false
};

const slice = createSlice({
  name: 'waterfallFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getWaterfallFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWaterfallFlow.fulfilled, (state, action) => {
        const { waterfall_flow } = action.payload;
        const waterfallFlow = { ...state.waterfallFlow, ...waterfall_flow };
        
        state.loading = false;
        state.waterfallFlow = waterfallFlow;
      })
      .addCase(getWaterfallFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createWaterfallFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createWaterfallFlow.fulfilled, (state, action) => {
        const { waterfall_flow } = action.payload;
        
        state.loading = false;
        state.waterfallFlow = waterfall_flow;       
      })
      .addCase(createWaterfallFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateWaterfallFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateWaterfallFlow.fulfilled, (state, action) => {
        const { status, waterfall_flow } = action.payload;
        const updatedWaterfallFlow = { ...state.waterfallFlow, ...waterfall_flow };
        
        state.loading = false;
        if (status === 204) state.waterfallFlow = updatedWaterfallFlow;       
      })
      .addCase(updateWaterfallFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteWaterfallFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteWaterfallFlow.fulfilled, (state, action) => {
        const { status } = action.payload;
        
        state.loading = false;
        if (status === 204) state.waterfallFlow = initialState.waterfallFlow;       
      })
      .addCase(deleteWaterfallFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveWaterfallFlow, state => {
        state.waterfallFlow = initialState.waterfallFlow;
      })
  }
})

export default slice.reducer;